import { useState } from 'react';
import { autoPlacement, autoUpdate, offset, useFloating } from '@floating-ui/react';

import { PaymentReconciliationDetailsData } from 'pages/PaymentReconciliation/PaymentReconciliationDetails/types';

import { DiscrepanciesModal } from './DiscrepanciesModal';

export const DiscrepancyBadge = ({
  item,
  currency,
}: {
  item: PaymentReconciliationDetailsData['data']['line_items'][number];
  currency: string | undefined | null;
}) => {
  const [hovered, setHovered] = useState(false);
  const { refs, floatingStyles } = useFloating({
    open: hovered,
    onOpenChange: setHovered,
    placement: 'right',
    strategy: 'fixed',
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(8),
      autoPlacement({
        allowedPlacements: ['right', 'left'],
      }),
    ],
  });

  const percentage = item.discrepancy_percentage;
  if (percentage >= 0) {
    return <span>{formatPercentage(percentage)}</span>;
  }

  const corrections = item.corrections;
  return (
    <div className="flex justify-end text-end">
      <div
        className="rounded-md border border-gray-200 px-2 py-1 text-red-700"
        ref={refs.setReference}
        onMouseOver={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {formatPercentage(-percentage)}
      </div>
      {hovered && (
        <DiscrepanciesModal
          dueAmount={item.line_due_amount}
          remittedAmount={item.line_remitted_amount}
          ref={refs.setFloating}
          style={floatingStyles}
          corrections={corrections}
          currency={currency}
        />
      )}
    </div>
  );
};

const formatPercentage = (value: number) => {
  return new Intl.NumberFormat('default', {
    style: 'percent',
    maximumFractionDigits: 2,
  }).format(value / 100);
};
